<script>


export default {
  components: {},
  name: "reviewScreenVersions",
  methods: {
    SaveReviewScreenVersion: async function () {
      try {
        await this.$A.AccountService.SetAccountReviewScreenTheme(this.reviewScreenTheme);
        _.set(this.$A, 'Auth.account.themeSettings.reviewScreenTheme', this.reviewScreenTheme);
        this.$A.SaveSessionData(this.$A.Auth);
        self.$A.AlertUser(
            "Review Screen Theme Saved",
            "success",
            10000
        );
      } catch (err) {
        self.$A.AlertUser(
            "Failed to save Review Screen Theme. Please, try again.",
            "warning",
            10000
        );
      }
    },
  },
  data() {
    return {
      reviewScreenTheme: 0,
      options: [
        {reviewScreenTheme: 10, text: "Modern"},
        {reviewScreenTheme: 0, text: "Minimal"},
      ],
    }
  },
  mounted() {
    this.reviewScreenTheme = _.get(this.$A, 'Auth.account.themeSettings.reviewScreenTheme', 0);
  },
  computed: {}
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Review Screen Theme</div>
      <div class="card-head-subtitle">Select the theme you'd like to use for your review screens.</div>
    </div>
    <div class="card-body">
      <div class="field">
        <label class="field-label">Theme</label>
        <v-select v-model="reviewScreenTheme"
                  :clearable="false"
                  :options="options"
                  :reduce="option => option.reviewScreenTheme"
                  class="theme-select"
                  label="text">
        </v-select>
      </div>
    </div>
    <div class="card-foot">
      <b-button class="primary-btn" @click="SaveReviewScreenVersion">Save</b-button>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.theme-select {
  max-width: 280px;
}
.theme-select ::v-deep .vs__dropdown-toggle {
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 38px;
  background: #fff;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
}
.theme-select ::v-deep .vs__selected {
  font-weight: 400;
  font-size: 13px;
  color: #1f2937;
}
.theme-select ::v-deep .vs__dropdown-menu {
  font-size: 13px;
  font-weight: 400;
}
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 120ms ease;
}
.primary-btn:hover,
.primary-btn:focus,
.primary-btn:active {
  background: #017a48 !important;
  color: #fff;
}
@media (max-width: 575px) {
  .primary-btn {
    width: 100%;
  }
}
</style>
